<template>
    <ui-modal
        name="user-manager-profile"
        :title="item.title"
        size="xs"
        :icon="item.icon"
        color-circle="icon-danger">
        <div>
            <div v-if="item.type == 'edit'">
                <form-users-edit :data-teams="dataTeams" :load-teams="loadTeams" :groups="item.data.data" @imput="setEquipe" @desactive="desactive" :group="user.user_group"/>
            </div>
            <div v-if="item.type == 'remove'">
                <div v-if="!['admin', 'collaborator', 'broker', 'manager', 'supervisor'].includes(item.group)">
                    <dinamic-delete :other-teans="item.data.dinamics" :user="{group: item.group, name: item.user}" @desactive="desactive" @input="newUser"/>
                </div>
                <div v-if="item.group == 'admin' || item.group == 'collaborator'">
                    <admin-or-collaborator-delete :user="{group: item.group, name: item.user}" @desactive="desactive" @input="newUser"/>
                </div>
                <div v-if="item.group == 'supervisor' || item.group == 'manager'">
                    <supervisor-or-manager-delete :data-teams="dataTeams" :load-teams="loadTeams" :user="{group: item.group, name: item.user, id: user.id}" :id-user="item.id" @desactive="desactive" @input="newUser"/>
                </div>
                <div v-if="item.group == 'broker'">
                    <broker-delete :data-teams="dataTeams" :load-teams="loadTeams" :id-user="item.id" :user="{group: item.group, name: item.user}" @desactive="desactive" @input="newUser"/>
                </div>
            </div>
            <div v-if="item.type == 'equipe'">
                <div v-if="item.group == 'broker'">
                    <equipe-broker :data-teams="dataTeams" :load-teams="loadTeams" :user="user" @input="setEquipe" />
                </div>
                <div v-if="item.group == 'manager'">
                    <equipe-manager :data-teams="dataTeams" :load-teams="loadTeams" :user="user" @input="setEquipe" />
                </div>
                <div v-if="item.group == 'supervisor'">
                    <equipe-supervisor :data-teams="dataTeams" :load-teams="loadTeams" :user="user" @input="setEquipe" />
                </div>
            </div>
            <div class="footer">
                <div class="cancel" @click="close">Cancelar</div>
                <ui-button v-if="item.type == 'remove'" class="danger" :disabled='activeButton.remove' @click="deleteUser">Remover</ui-button>
                <ui-button v-if="item.type == 'edit' || item.type == 'equipe'" class="success" :disabled="activeButton.save" @click="save()">Salvar</ui-button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
import   helpers                                                                             from '@/mixins/helpers'
import { uiModal,                                                                          } from '@/components/ui/modal'
import { uiButton                                                                          } from '@/components/ui/buttons'
import { adminOrCollaboratorDelete, supervisorOrManagerDelete, brokerDelete, dinamicDelete } from './form-users-delete'
import { equipeBroker, equipeManager, equipeSupervisor                                     } from './form-users-equipe'
import formUsersEdit                                                                         from './form-users-edit'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'ui-modal-manager',
    components: {
        uiModal,
        uiButton,
        adminOrCollaboratorDelete,
        supervisorOrManagerDelete,
        brokerDelete,
        dinamicDelete,
        equipeBroker,
        equipeManager,
        equipeSupervisor,
        formUsersEdit
    },
    mixins: [helpers],
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        user:{
            type: [String, Object],
            default: () => {}
        }
    },

    data() {
        return {
            activeButton: {
                remove: true,
                save: true
            },
            multiple: false,
            selectManager: '',
            newTeam: null,
            managers: null,
            errorTeam: false,
            errorManager: false,
            setNewUser: null,
            load: false,
            setNewTeamSelect: false,
            search: ''
        }
    },

    computed: {
        ...mapGetters('profile', {
            dataTeams: 'getTeams',
            loadTeams: 'getTeamsLoad'
        }),

         equipes() {
            let equipe = []
            if(this.item.data.teans) {
                this.item.data.teans.map( result => {
                    equipe.push({value: result.id, label: result.name, id: result.id})
                })
            }
            return equipe
        }
    },

    mounted() {
        this.$root.$on('modal-return-event-delete-user', () => {
            this.$router.push({ name: 'users.teams' })
        })
        this.loadDataTeans({click: true, hasData: this.dataTeams.length > 1 && this.user.user_group != "supervisor"})
        this.$root.$on('select-v2-ajax-search-change-profile-teams', async (val) => {
            if(val.search != this.search) await this.setSearch(val.search)
            this.search = val.search
            this.loadDataTeans({search: true, data: null})
        })
    },

    beforeDestroy() {
        this.$root.$off('modal-return-event-delete-user')
        this.$root.$off('select-v2-open-event-change-profile-teams')
        this.$root.$off('select-v2-ajax-search-change-profile-teams')
    },

    methods: {

        ...mapActions('profile', {
                loadDataTeans: 'loadDataTeans',
                setSearch: 'setSearch'
            }),
        close() {
            this.value=''
            this.$root.$emit('modal-close-user-manager-profile')
        },
        selectedManager (a) {
                if (a && a.length == 0) {
                return this.desactive('save', true)
            } else {
                return this.desactive('save', false)
            }
        },
        //seta nova equipe pa
        setEquipe (value) {
            this.selectGroup = null
            if(!value) {
                this.setNewTeamSelect = value
            } else {
                if(value.group == 'broker') {
                    this.newTeam          = value.team
                    this.selectManager    = value.manager
                    this.setNewTeamSelect = true
                    this.selectUser = value.group
                    this.selectedManager(value)
                } else {
                    this.newTeam = value.team
                    this.selectUser = value.group
                    this.setNewTeamSelect = false
                    this.selectedManager(value)
                }
            }
        },

        // salvar informação de atualização
        save() {
            this.activeButton.save = false
            let fd = new FormData
            if (!this.selectUser || this.selectUser.length == 0 && this.setNewTeamSelect) {
                return
            }
            fd.set('user_group', this.selectUser)
            fd.set('email', this.user.email)
            if (this.selectUser == 'supervisor' || this.selectUser == 'broker' || this.selectUser == 'manager') {
                if(!this.newTeam || this.newTeam.length == 0) {
                    this.errorTeam = true
                    return
                }
                if(this.selectUser === 'broker' && !this.selectManager && !this.setNewTeamSelect) {
                    this.errorManager = true
                    return
                }
                if (this.newTeam.length) {
                    for (let index = 0; index < this.newTeam.length; index++) {
                        fd.set(`changeTeamOrManager[${index}]`, this.newTeam[index])
                    }
                } else {
                    fd.set('changeTeamOrManager', this.newTeam)
                }
            }
            if (this.selectUser == 'broker') {
                fd.set('changeTeamOrManager', this.selectManager)
            }
            this.$root.$emit('change-user-profile', fd)
            this.$emit('close')
            this.activeButton.save = true
        },
        //função para desativar e ativar botão
        desactive (type, vf) {
            this.$set(this.activeButton, type, vf)
        },
        // traz a informação para transferir e passar os dados para outro usuário
        newUser(user, manager, team) {
            this.setNewUser = {
                newUser: user,
                newManager: manager,
                newTeam: team
            }
        },
        // delete o usuário
        deleteUser() {
            this.$root.$emit('modal-msg-open-delete-user', {
                method: 'transfer',
                url: this.item.id,
                id: '',
                formdata: this.setNewUser
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>